import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'flightDate'
})
export class FlightDatePipe implements PipeTransform {
  transform(value: moment.Moment): string {
    if (!value || !moment.isMoment(value)) {
      return '';
    }

    // Use local time for all date comparisons
    const today = moment().local().startOf('day');
    const tomorrow = moment().local().add(1, 'day').startOf('day');
    const flightDate = moment(value).local().startOf('day');

    if (flightDate.isSame(today, 'day')) {
      return 'today';
    } else if (flightDate.isSame(tomorrow, 'day')) {
      return 'tomorrow';
    } else {
      return flightDate.format('ddd D MMM');
    }
  }
}

